import React, { useState } from "react";
import "./HeaderStyle.js";
import { useStateValue } from "../StateProvider";
import NodeZephyr from "../../images/nodezephyr.png";
import {
  HeaderContainer,
  Navbar,
  NavSection,
  NavSearch,
  SearchBar,
  MenuIcon,
  SearchIcon,
  NavLogo,
  LogoImg,
} from "./HeaderStyle";

function Header({ toggle, handleSearchVisibility, isVisible }) {
  const [{ user }, dispatch] = useStateValue();

  return (
    <HeaderContainer>
      <Navbar>
        <MenuIcon onClick={toggle} />

        <NavLogo to="/">
          <LogoImg src={NodeZephyr} />
          <h2>Node-Zephyr</h2>
        </NavLogo>

        <NavSearch>
          <SearchIcon onClick={handleSearchVisibility} />
          <SearchBar placeholder="Search" isVisible={isVisible} />
        </NavSearch>
      </Navbar>
    </HeaderContainer>
  );
}

export default Header;
